import { useState } from 'react';
import { NJButton, NJIcon, NJIconButton, NJSegmentedControl, NJSegmentedControlButton, NJText } from '@engie-group/fluid-design-system-react';
import { VIEWERS, VIEWER_IDS, isViewerId } from './permissions';
import type { OptimisationPermissions, ViewerId } from './types';

/** Prototype-only panel (not part of Nemo): switch the access profile viewing the page. */
export default function ViewerSwitcher({ viewer, perms, onChange, onReset }: { viewer: ViewerId; perms: OptimisationPermissions; onChange: (v: ViewerId) => void; onReset: () => void }) {
    const [open, setOpen] = useState(true);
    const rights = perms.canEdit ? 'Écriture (copie, suppression, création acceptées)' : 'Lecture seule (copie masquée ; création et suppression refusées par le serveur)';
    return (
        <aside
            aria-label="Contrôles du prototype"
            style={{
                position: 'fixed',
                right: 24,
                bottom: 56,
                zIndex: 1000,
                width: open ? 340 : 'auto',
                background: 'var(--nj-semantic-color-background-neutral-primary-default)',
                border: '2px dashed var(--nj-semantic-color-border-brand-moderate-default)',
                borderRadius: 'var(--nj-semantic-size-border-radius-md, 8px)',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18)',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 8px 8px 16px' }}>
                <NJIcon name="science" size="sm" />
                <NJText scale="sm" style={{ fontWeight: 700, flex: 1 }}>
                    Prototype — {open ? 'Voir en tant que' : VIEWERS[viewer].label}
                </NJText>
                <NJIconButton
                    icon={open ? 'expand_more' : 'expand_less'}
                    label={open ? 'Réduire les contrôles du prototype' : 'Ouvrir les contrôles du prototype'}
                    variant="secondary"
                    scale="sm"
                    onClick={() => setOpen((o) => !o)}
                />
            </div>
            {open && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '0 16px 16px' }}>
                    <NJSegmentedControl label="Voir en tant que" size="sm" value={viewer} onChange={(value) => isViewerId(value) && onChange(value)}>
                        {VIEWER_IDS.map((id) => (
                            <NJSegmentedControlButton key={id} label={VIEWERS[id].label} value={id} />
                        ))}
                    </NJSegmentedControl>
                    <NJText scale="sm" variant="secondary">
                        {VIEWERS[viewer].description} Droits calculés : <strong>{rights}</strong>.
                    </NJText>
                    <div>
                        <NJButton label="Réinitialiser les données" variant="secondary" emphasis="minimal" scale="sm" icon="restart_alt" onClick={onReset} />
                    </div>
                </div>
            )}
        </aside>
    );
}
